import React, {FC} from 'react'
import { Divider, Grid, Link, Typography } from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import { useIntl } from 'src/common/razzle-platform-translate'
import RegisterForm from 'src/common/razzle-platform-user/Authentication/Register/RegisterForm'
import {useAuth} from 'src/common/razzle-platform-user/Authentication/hooks'
import FacebookOAuth from 'src/common/razzle-platform-user/Authentication/OAuth/FacebookOAuth'
import GoogleOAuth from 'src/common/razzle-platform-user/Authentication/OAuth/GoogleOAuth'
import {SOCIAl_OAUTH_ENABLED, FACEBOOK_OAUTH_KEY, GOOGLE_OAUTH_KEY} from 'src/common/razzle-platform-user/configs'


const useStyles = makeStyles(theme => ({
    container: {
        paddingBottom: 30,
        paddingLeft: 10,
        paddingRight: 10
    },
    titleContainer: {
        marginBottom: 10
    },
    title: {
        marginTop: 0
    },
    dividerContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 24,
        marginBottom: 24
    },
    divider: {
        width: 50
    },
    or: {
        marginLeft: 8,
        marginRight: 8,
        fontWeight: 'bold'
    },
    connectionLinkContainer: {
        marginTop: 20
    },
    connectionLink: {
        marginLeft: 10
    }
}))


const Register: FC<any> = (props: any) => {

    const { displayLogin } = useAuth()
    const classes = useStyles(props);
    const { formatMessage } = useIntl()

    return (
        <div className={classes.container}>
            <Grid container={true} item={true} xs={12} direction="row" justify="center" className={classes.titleContainer}>
                <h1 className={classes.title} >{formatMessage({ id: 'Inscription', defaultMessage: 'Inscription' })}</h1>
            </Grid>
            <RegisterForm
                textField={props.textField}
                passwordField={props.passwordField}
                checkBoxField={props.checkBoxField}
                submitButton={props.submitButton}
            />
            { SOCIAl_OAUTH_ENABLED  && (GOOGLE_OAUTH_KEY || FACEBOOK_OAUTH_KEY) &&
                <div className={classes.dividerContainer}>
                    <Divider className={classes.divider} />
                        <span className={classes.or} >{formatMessage({ id: 'OR', defaultMessage: 'OR' })}</span>
                    <Divider className={classes.divider} />
                </div>
            }
            <Grid container={true} spacing={2}>
                {SOCIAl_OAUTH_ENABLED && GOOGLE_OAUTH_KEY &&
                    <Grid container={true} item={true} xs={12} direction="row" justify="center">
                        <Grid item={true} xs={9} md={9}>
                            <GoogleOAuth googleButton={props.googleButton} />
                        </Grid>
                    </Grid>
                }
                {SOCIAl_OAUTH_ENABLED && FACEBOOK_OAUTH_KEY &&
                    <Grid container={true} item={true} xs={12} direction="row" justify="center">
                        <Grid item={true} xs={9} md={9}>
                            <FacebookOAuth facebookButton={props.facebookButton} />
                        </Grid>
                    </Grid>
                }

                <Grid container justify="center" className={classes.connectionLinkContainer}>
                    <Grid item>
                        <Typography variant="body2" >{formatMessage({ id: 'Vous avez déjà un compte?', defaultMessage: 'Vous avez déjà un compte?'})}
                            <Link href="#" onClick={displayLogin} variant="body2" className={classes.connectionLink}>
                                {formatMessage({ id: 'Connexion', defaultMessage: 'Connexion'})}
                            </Link>
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </div>
    )
}


export default Register
